// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__1WAkh","footer":"ModalError_footer__O0-QY"};